/** 0 件の頁に置く場面の絵 (16 対 9、字の無い絵)。絵の住所は 1 か所にまとめ、描き直したら日付を変えた別の名前で置く (public は 1 年 immutable) */
export const EMPTY_ART_SRC = {
  search: "/empty-art/empty-search-2026-10-24.svg",
  notice: "/empty-art/empty-notice-2026-10-24.svg",
  dojo: "/empty-art/empty-dojo-2026-10-23.svg",
  /** ターミナルとつながりの切れた印 (クラウドエディターを止める) */
  server: "/empty-art/error-server-2026-10-24.svg",
  yet: "/empty-art/empty-yet-2026-10-19.svg",
  error: "/empty-art/error-server-2026-10-24.svg",
  /** 読み込み中の共通の場面。土の山に座るもぐらが、土けむりを立てて点の道をエディターの窓へ急ぐ */
  loading: "/empty-art/loading-2026-10-22b.svg",
  /** 満員で待つ。6 席の PC のうち 5 席がふさがり、最後の 1 席がもうすぐ空く。かめが砂時計の横で待つ */
  busyWait: "/empty-art/busy-wait-2026-10-24.svg",
  /** スマホで開いたとき。小さなスマホの画面から、手順とエディターとプレビューが並ぶ PC の画面へ。うさぎがひらめく */
  openOnPc: "/empty-art/open-on-pc-2026-10-24.svg",
  /** メンテナンス中。柵の向こうで窓の中の歯車を直し、ヘルメットのもぐらが番をする */
  maintenance: "/empty-art/maintenance-2026-10-22.svg",
  /** 届いた手紙が 0 通。ふくろうが空の手紙受けの前で、降りてくる封筒を見上げる */
  letters: "/empty-art/letters-empty-2026-10-24.svg",
  /** 有料プランの契約が無い。かめと、点線の枠だけの会員の札 */
  subscription: "/empty-art/subscription-empty-2026-10-23.svg",
  /** 予定が無い。何も書いていない暦と、湯のみを置いて一息つくもぐら */
  schedule: "/empty-art/schedule-empty-2026-10-22.svg",
  /** 学習パスを全部済ませた。丘の上に着いたかめと大きな旗 */
  pathDone: "/empty-art/path-done-2026-10-22.svg",
  /** 技術面接の練習の読み込み中。土の山に座るもぐらが、土けむりを立てて問いと答えの吹き出しへ急ぐ */
  interviewLoading: "/empty-art/interview-loading-2026-10-22b.svg",
  /** ロードマップの読み込み中。かめが点の道を、駅の並ぶ地図の板へ歩く */
  roadmapLoading: "/empty-art/loading-roadmap-2026-10-23b.svg",
  /** 体験の作品の読み込み中。うさぎが小さなタイルを、作品の板へ運ぶ */
  workLoading: "/empty-art/loading-work-2026-10-23.svg",
  /** クラウドエディターの入口の頭。掲示板の 4 枚の札から、もぐらがエディターの窓へ。何を作るかを選ぶ場面 */
  entryHead: "/empty-art/entry-head-2026-10-24.svg",
  /** クラウドエディターがまだ開いていない (準備中)。窓の中は点線の枠だけで、ヘルメットのもぐらが見上げる */
  editorSoon: "/empty-art/editor-soon-2026-10-23.svg",
  /** クラウドエディターは受講生のみ (体験の人)。窓の前に会員の札と鍵を差し出すうさぎ */
  editorMembers: "/empty-art/editor-members-2026-10-23.svg",
  /** 実践プロジェクトのエディターの読み込み中。ヘルメットのもぐらが、コードの窓とターミナルの待つ所へ向かう */
  sandboxLoading: "/empty-art/loading-sandbox-2026-10-23.svg",
} as const;

export type EmptyArtName = keyof typeof EMPTY_ART_SRC;

export function EmptyArt({ name, className = "" }: { name: EmptyArtName; className?: string }) {
  return (
    <img
      src={EMPTY_ART_SRC[name]}
      alt=""
      width={1200}
      height={675}
      loading="lazy"
      decoding="async"
      data-empty-art={name}
      className={`mx-auto aspect-[1200/675] h-auto w-full max-w-[400px] rounded-[2px] border border-main ${className}`.trim()}
    />
  );
}
